import EventManager from "../eventManager.js"

export default class FiltersManager extends EventManager {
  constructor (options) {
    super()

    this.settings = $.extend({}, {
      }, options)

  }

  handle ($form) {
    let $validate = $form.find('> button.button')
    let $close = $form.find('> .fa-times')
    let $buttons = $form.find('.drop-button.filter')
    
    this.updateSummary($buttons)
    
    $buttons.find('ul > li').on('click', event => {
      if (event.currentTarget === event.delegateTarget) {
        $validate.addClass('shake')
        this.updateSummary($(event.delegateTarget).closest('.drop-button.filter'))
      }
    })
    $form.prev('button')
      .click(() => $form.slideDown(200))
    
    $close.click(() =>  $form.css({ display: '' }))
    
    if ($buttons.length === 0) {
      $form.prev('button').hide()
    } else {
      $validate.show()
    }
    $form.css({ display: '' })
  }

  handleSelectionChips ($filterChips) {
    // Handle remove button
    $filterChips.find('i').click(e => {
      const $chip = $(e.delegateTarget).closest('.filter-chip')
      const $form = $('#' + $chip.data().formid)
      let varName = null

      if ($chip.data().type === 'regular') {
        varName = 'filtres'
      } else if ($chip.data().type === 'brand') {
        varName = 'marque'
      }

      if (varName) {
        this.updateSummary($form.find(`[name="${varName}[]"][value="${$chip.data().id}"]`)
          .prop('checked', false)
          .closest('.drop-button.filter'))
        $form.submit()
      }
    })
  }

  updateSummary ($buttons) {
    $buttons.each(function () {
      const count = $(this).find('input:checked').length
      let $span = $(this).find('> p > span.count')
      if (count && $span.length === 0) {
        $(this).find('> p').append(`&nbsp;<span class="count">(${count})</span>`)
      } else {
        $span.html(count ? `(${count})` : '')
      }
    })
  }
}
